import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/SOLineItemHistory'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class SOLineItemHistoryStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "SOLineItemHistoryStore",
			variables: true,
		})
	}
}

export async function load_SOLineItemHistory(params) {
  await initClient()

	const store = new SOLineItemHistoryStore()

	await store.fetch(params)

	return {
		SOLineItemHistory: store,
	}
}
